$(function () {
    $('#change-offer-status-form .js__submit-button')
        .on("click", function (e) {
            e.preventDefault();

			let form = e.target.form;
			
			$(".js__submit-button").prop('disabled', true);

            $.ajax({
                url: form.action,
                method: "POST",
                data: $(e.target).data('payload'),

                // TODO: Add headers to global setup
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
					location.reload();
					$(".js__submit-button").prop('disabled', false);
                })
                .fail(function (response) {
					alert("Something went wrong. Please try again later.");
					$(".js__submit-button").prop('disabled', false);
                });

            return false;
        });
});
